export class BaseComponent {
}
//# sourceMappingURL=BaseComponent.js.map